/**
 * @file SVG icon factory
 */
import './icon.css';
import { escapeHTML } from './util';

const baseClassName = 'platform-design-icon';

/**
 *
 * @param content string
 * @param width number
 * @param height number
 * @param type 'Gallery' | 'Icon'
 * @returns {function({className: *, title: *, spin: *, [p: string]: *})}
 */
export default function createIcon({ content, width, height }, type) {
  return ({ className, title, spin, ...props }) => {
    const iconClasses = [baseClassName, className];

    if (spin) {
      iconClasses.push(`${baseClassName}-spin`);
    }

    if (type === 'Icon') {
      iconClasses.push(`${baseClassName}-icon`);
    }

    if (type === 'Gallery') {
      iconClasses.push(`${baseClassName}-gallery`);
    }

    const iconClassName = iconClasses.join(' ');
    const { tabIndex } = props;
    const markup = {
      __html: (title ? `<title>${escapeHTML(title)}</title>` : '') + content,
    };

    return (
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        className={iconClassName}
        focusable={tabIndex === '0' ? null : false}
        /* eslint-disable react/no-danger */
        dangerouslySetInnerHTML={markup}
        /* eslint-enable react/no-danger */
        {...props}
      />
    );
  };
}
